const Loading = (props) => {
    return (
        <span>外部讀取中...</span>
    );
};

export default Loading;
